import { Button, Empty } from "antd";

import { useNavigate } from "react-router-dom";
import { roles } from "~/config";
import useAuthorization from "~/hooks/useAuthorization";

// eslint-disable-next-line react/prop-types
const EmptyResult = ({ navigateTo, description, state = true }) => {
  const navigate = useNavigate();
  const { userHasRequiredRole } = useAuthorization([roles.ADMIN]);

  return (
    <Empty
      image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
      imageStyle={{ height: 60 }}
      description={
        <span>{userHasRequiredRole ? description : "No data available"}</span>
      }
    >
      {userHasRequiredRole && (
        <Button
          onClick={() => navigate(navigateTo, { state: state })}
          type="primary"
        >
          Create
        </Button>
      )}
    </Empty>
  );
};

export default EmptyResult;
